export const BACKUP_STATUS_CREATE_RESET = 'BACKUP_STATUS_CREATE_RESET'
export const BACKUP_STATUS_CREATE_SET_CREATED = 'BACKUP_STATUS_CREATE_SET_CREATED'
export const BACKUP_STATUS_CREATE_SET_ERROR = 'BACKUP_STATUS_CREATE_SET_ERROR'
export const BACKUP_STATUS_CREATE_SET_VIOLATIONS = 'BACKUP_STATUS_CREATE_SET_VIOLATIONS'
export const BACKUP_STATUS_CREATE_TOGGLE_LOADING = 'BACKUP_STATUS_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup_status/create/mutation_types.js